import axios from "axios";
import {TOKEN} from "@/store/mutation-types";

axios.defaults.timeout = 30000;
// axios.defaults.withCredentials = true;
// axios.defaults.headers.get['Content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
// export const baseURL = 'http://192.168.88.192:8081'
export const baseURL = process.env.VUE_APP_API_URL;
axios.defaults.baseURL = baseURL;

axios.interceptors.request.use(config => {
    console.log('config,',config.url)
    if (localStorage.getItem(TOKEN)) {
        config.headers.Authorization = localStorage.getItem(TOKEN)
    }

    return config
}, error => {
    return Promise.reject(error)
})
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            if (response.data.ret === 401) {
                localStorage.setItem(TOKEN, '')
                getToken().then(r => {
                    console.log(r)
                });
            }
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },

    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                    break;
                case 404:
                    break;
            }
            return Promise.reject(error.response);
        }
    }
);

export function getToken() {

    return get('', {s:'App.Token_Token.token'})
        .then(function (res) {
            if (res.ret === 200 && res.data.access_token) {
                localStorage.setItem('token', res.data.access_token)
            }
            console.log(res);
        })
        .catch(function (err) {
            console.log(err);
        });
}

export function get(url, params = {}) {
    return new Promise(
        //一个正常的结果，一个异常的结果
        (resolve, reject) => {
            axios.get(url, {params: params})
                .then(response => {
                    resolve(response.data);
                })
                .catch(
                    err => {
                        reject(err);
                    }
                )
        }
    );

}

export function post(url, data = {}) {
    return new Promise(
        //一个正常的结果，一个异常的结果
        (resolve, reject) => {
            axios.post(url, data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(
                    err => {
                        reject(err);
                    }
                )
        }
    );

}